<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
  v-card
    div.py-6.px-10
      .text-md Are you sure to delete this family relationship?
      v-sheet.neutral300.pa-4.mt-2.rounded-lg
        .text-sm Name : 
          span.font-semibold {{ toDeleteItem.related_person.name }}
        .text-sm Relationship : 
          span.font-semibold {{ toDeleteItem.relationship.name }}
      .text-md.mt-2 This relationship will be deleted immediately. You can't undo this action.
    v-divider
    v-card-actions.px-6
      v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(:loading="loading" color="danger500" depressed dark @click="handleDelete") {{ $t('confirm') }}
  </template>
  
  <script>
  
  export default {
    props: {
      open: {
        type: Boolean,
      },
      toDeleteItem: {
        type: Object,
        default: () => {
          return {
            name: null,
            relationship: null
          }
        }
      },
    },
    data() {
      return {
        loading: false
      }
    },
    computed: {
      showDialog: {
        get() {
          return this.open
        },
        set(newValue) {
          this.$emit('update:open', newValue)
        }
      }
    },
    methods: {
      closeDialog () {
        this.$emit('cancel')
        this.showDialog = false
      },
      handleDelete () {
        this.loading = true
        this.$emit('delete')
      }
    },
  }
  </script>